import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Location } from 'app/models/location.model';
import { MapboxService } from 'app/services/mapbox/mapbox.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocationService } from 'app/services/locations/location.service';

declare const swal: any;

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.css']
})
export class LocationDetailComponent implements OnInit {
  
  location: Location;
  domainId: number;
  locationId: number;
  
  constructor(private mapService: MapboxService,
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<LocationDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private locationService: LocationService) {}

  ngOnInit() {
    console.log(this.data);
    this.mapService.buildMap({marker: this.data.geolocation}); 
    this.domainId = parseInt(this.data.domainId);
    this.locationId = this.data.locationId;
  }

  locationForm = this.formBuilder.group({
    name: [this.data.name, Validators.required],
    address: [this.data.address, Validators.required],
    geolocation: [this.data.geolocation, Validators.required]
  });

  saveLocation(){
    try {
      this.locationForm.value.geolocation = this.mapService.marker.getLngLat();
      this.location = {
        name: this.locationForm.value.name,
        address: this.locationForm.value.address,
        geoLocation: { lng: this.locationForm.value.geolocation.lng, lat: this.locationForm.value.geolocation.lat },
        domain: this.domainId,
        id: this.locationId
      };
      console.log({
        status: this.locationForm.status,
        value: this.locationForm.value
      })
      if(this.locationForm.status !== "INVALID"){
        this.openAlert(0);
      }else{
        this.locationService.saveLocation(this.location).subscribe(result => {
          this.openAlert(1);
          console.log('location saved!');
          this.dialogRef.close();
        })
      }
    } catch (error) {
      console.error(error);
    }
  }

  cancel(){
    this.dialogRef.close();
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Guardado correctamente',
          text: '',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }
}
